import beziers from 'core/beziers';

const easings = {};

Object.keys(beziers).forEach((key) => {
  easings[key] = `cubic-bezier(${beziers[key].join(',')})`;
});

export default easings;
